// import { useState } from "react"
// import { useForm } from "react-hook-form"
// import { useNavigate } from "react-router-dom"
// import { Button } from "../components/ui/button"
// import { Eye, EyeOff, LogIn, Lock, Mail, Sparkles } from "lucide-react"
// import { Input } from "../components/ui/input"
// import { Label } from "../components/ui/label"
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
//   CardFooter,
// } from "../components/ui/card"
// import { useToast } from "../hooks/useToast"
// import { useAuth } from "../contexts/AuthContext"

// type LoginForm = {
//   email: string
//   password: string
// }

// export function Login() {
//   const [loading, setLoading] = useState(false)
//   const { toast } = useToast()
//   const { login } = useAuth()
//   const navigate = useNavigate()
//   const { register, handleSubmit } = useForm<LoginForm>()
//   const [showPassword, setShowPassword] = useState(false)

//   console.log("Login.tsx: Component mounted/rendered");

//   const onSubmit = async (data: LoginForm) => {
//     try {
//       console.log("Login.tsx: Form submission started");
//       console.log("Login.tsx: Form data received:", { email: data.email, password: "***" });

//       setLoading(true)
//       console.log("Login.tsx: Loading state set to true");

//       console.log("Login.tsx: Calling login from AuthContext");
//       await login(data.email, data.password);

//       console.log("Login.tsx: Login successful, showing success toast");
//       toast({
//         title: "Success",
//         description: "Logged in successfully",
//       })

//       console.log("Login.tsx: Navigating to home page");
//       navigate("/dashboard");
//       console.log("Login.tsx: Navigation completed");

//     } catch (error) {
//       console.error("Login.tsx: Login error occurred:", error)
//       console.error("Login.tsx: Error message:", error?.message)

//       console.log("Login.tsx: Showing error toast");
//       toast({
//         title: "Error",
//         description: "Invalid Credentials",
//       })
//     } finally {
//       console.log("Login.tsx: Setting loading state to false");
//       setLoading(false)
//     }
//   }

//   return (
//     <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
//       {/* Background decorative elements */}
//       <div className="absolute inset-0 z-0">
//         {/* Animated floating shapes */}
//         <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-r from-blue-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
//         <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-l from-purple-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
//         <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-gradient-to-r from-indigo-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-60 animate-pulse delay-500"></div>

//         {/* Grid pattern */}
//         <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik02MCAwSDB2NjBoNjBWMHpNMCAwaDYwdjYwSDBWMHoiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wMSkiLz48L2c+PC9zdmc+')] opacity-20"></div>
//       </div>

//       {/* Sparkles decoration */}
//       <div className="absolute top-6 right-6 text-blue-400 dark:text-blue-300 opacity-60">
//         <Sparkles size={24} className="animate-spin-slow" />
//       </div>
//       <div className="absolute bottom-6 left-6 text-purple-400 dark:text-purple-300 opacity-60">
//         <Sparkles size={20} className="animate-spin-slow" />
//       </div>

//       {/* Login Card */}
//       <div className="relative z-10 w-full max-w-md mx-4">
//         <Card className="w-full backdrop-blur-sm bg-white/90 dark:bg-gray-800/90 border-gray-200 dark:border-gray-700 shadow-2xl shadow-blue-500/10 dark:shadow-blue-500/5 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20">
//           <CardHeader className="text-center pb-6">
//             <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg">
//               <Lock className="h-8 w-8 text-white" />
//             </div>
//             <CardTitle className="text-2xl font-bold text-gray-800 dark:text-white">
//               Welcome back
//             </CardTitle>
//             <CardDescription className="text-gray-600 dark:text-gray-300">
//               Enter your credentials to access your account
//             </CardDescription>
//           </CardHeader>

//           <CardContent>
//             <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//               <div className="space-y-3">
//                 <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
//                   Email Address
//                 </Label>
//                 <div className="relative">
//                   <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
//                   <Input
//                     id="email"
//                     type="email"
//                     placeholder="you@example.com"
//                     className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
//                     {...register("email", { required: true })}
//                   />
//                 </div>
//               </div>

//               <div className="space-y-3">
//                 <div className="flex justify-between items-center">
//                   <Label htmlFor="password" className="text-gray-700 dark:text-gray-300 font-medium">
//                     Password
//                   </Label>
//                   <p
//                     onClick={() => navigate("/forgot-password")}
//                     className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline cursor-pointer transition-colors"
//                   >
//                     Forgot Password?
//                   </p>
//                 </div>
//                 <div className="relative">
//                   <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
//                   <Input
//                     id="password"
//                     type={showPassword ? "text" : "password"}
//                     placeholder="Enter your password"
//                     className="pl-10 pr-12 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-400 transition-colors"
//                     {...register("password", { required: true })}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="absolute right-3 top-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
//                   >
//                     {showPassword ? (
//                       <EyeOff size={20} className="stroke-current" />
//                     ) : (
//                       <Eye size={20} className="stroke-current" />
//                     )}
//                   </button>
//                 </div>
//               </div>

//               <Button
//                 type="submit"
//                 className="w-full h-12 mt-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold shadow-lg shadow-blue-500/25 dark:shadow-blue-500/15 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/35 disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <div className="flex items-center justify-center">
//                     <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
//                     <span className="ml-2">Signing in...</span>
//                   </div>
//                 ) : (
//                   <>
//                     <LogIn className="mr-2 h-5 w-5" />
//                     Sign In
//                   </>
//                 )}
//               </Button>
//               <Button
//                 type="button"
//                 onClick={() => navigate("/")}
//                 className="w-full h-12 mt-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold shadow-md transition-all duration-300"
//               >
//                 ← Back to Home
//               </Button>
//             </form>
//           </CardContent>

//           <CardFooter className="flex justify-center pt-6 border-t border-gray-100 dark:border-gray-700">
//             <p className="text-gray-600 dark:text-gray-400 text-sm">
//               Don't have an account?{" "}
//               <Button
//                 variant="link"
//                 className="p-0 h-auto font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
//                 onClick={() => {
//                   console.log("Login.tsx: Navigate to register button clicked");
//                   navigate("/register")
//                 }}
//               >
//                 Sign up now
//               </Button>
//             </p>
//           </CardFooter>
//         </Card>

//         {/* Additional Info */}
//         <div className="mt-8 text-center">
//           <p className="text-sm text-gray-500 dark:text-gray-400 opacity-75">
//             Secure login with end-to-end encryption
//           </p>
//         </div>
//       </div>

//       {/* Footer note */}
//       <div className="absolute bottom-4 left-0 right-0 text-center">
//         <p className="text-xs text-gray-400 dark:text-gray-500">
//           Protected by advanced security protocols • © {new Date().getFullYear()}
//         </p>
//       </div>
//     </div>
//   )
// }



import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate, Navigate } from "react-router-dom"
import { Eye, EyeOff, ArrowRight, ArrowLeft } from "lucide-react"
import { FaUserClock, FaRobot, FaCheckCircle, FaShieldAlt, FaBuilding } from "react-icons/fa"
import { useToast } from "../hooks/useToast"
import { useAuth } from "../contexts/AuthContext"
import { getOrganizations, googleAuth } from "../api/auth"
import { takeEvictionMessage } from "../utils/session"
import { useGoogleIdentityButton } from "../hooks/useGoogleIdentityButton"

type LoginForm = {
  email: string
  password: string
}

interface Organization {
  head_office_id: string
  company_name: string
  organization: string
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState<"email" | "organizations" | "login">("email")
  const [organizations, setOrganizations] = useState<Organization[]>([])
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null)
  const [email, setEmail] = useState("")
  const { toast } = useToast()
  const { loginSelect, googleLoginSelect, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const { register, handleSubmit } = useForm<LoginForm>()
  const [showPassword, setShowPassword] = useState(false)
  // A sign-in lock has to outlive a toast. Three wrong passwords shut the
  // account until somebody acts, and a message that fades after four seconds
  // leaves people retrying a door that is not going to open. The backend sends
  // the whole sentence (utils/login_lockout.LOCKED_DETAIL); this only decides
  // that it deserves to stay on screen.
  const [lockNotice, setLockNotice] = useState<string | null>(null)
  // Google sign-in. The ticket stands in for the password: it proves Google
  // vouched for this email, and the workspace step trades it for a session.
  const [googleTicket, setGoogleTicket] = useState<string | null>(null)
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  // Arrow, not the function itself: the handler is declared further down, and
  // naming it here directly would read it before it exists.
  const googleButtonRef = useGoogleIdentityButton({
    clientId: GOOGLE_CLIENT_ID,
    enabled: step === "email",
    onCredential: (credential) => handleGoogleCredential(credential),
  })

  console.log("Login.tsx: Component mounted/rendered");

  // Single-session: explain a forced logout rather than leaving the user
  // wondering why they landed back here. This page has no plain-string error
  // banner (errors surface via the toast() calls below), so route through
  // that same mechanism instead of adding a second display.
  useEffect(() => {
    // Render verbatim: the stored value is already a complete sentence
    // (built at the point of eviction in utils/session.ts) — do not wrap it
    // in another "...used on ${message}." template here, or a heartbeat
    // eviction (whose stored value is already a full sentence) renders as a
    // garbled double sentence.
    const message = takeEvictionMessage();
    if (message) {
      toast({
        description: message,
        variant: "destructive",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Already signed in? Skip the form and go straight to the app. The public
  // landing page now lives in the Next.js site and has no auth awareness, so a
  // logged-in visitor who lands there and clicks "Sign in" would otherwise be
  // shown the login form again despite having a valid session.
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  // Step 1: Get organizations by email
  const handleGetOrganizations = async (data: LoginForm) => {
    try {
      console.log("Login.tsx: Getting organizations for email:", data.email);
      setLoading(true)
      setEmail(data.email)

      const response = await getOrganizations(data.email)
      console.log("Login.tsx: Organizations response:", response)

      if (response.success && response.organizations && response.organizations.length > 0) {
        setOrganizations(response.organizations)
        
        // If only one organization, auto-select it and go to login
        if (response.organizations.length === 1) {
          const singleOrg = response.organizations[0]
          setSelectedOrg(singleOrg)
          setStep("login")
          toast({
            title: "Success",
            description: `Logged in to ${singleOrg.company_name}`,
          })
        } else {
          // Multiple organizations - show selection screen
          setStep("organizations")
          toast({
            title: "Success",
            description: `Found ${response.organizations.length} organizations. Please select one.`,
          })
        }
      } else {
        toast({
          // title: "Error",
          description: "No organizations found for this email",
          variant: "destructive",
        })
      }
    } catch (error: any) {
      console.error("Login.tsx: Error getting organizations:", error)
      toast({
        // title: "Error",
        description: error.message || "Failed to fetch organizations",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  // Step 2: Select organization (only shown when multiple organizations exist)
  const handleSelectOrganization = (org: Organization) => {
    setSelectedOrg(org)
    // A Google ticket already proved who they are — asking for a password on
    // top of it would defeat the point of the button.
    if (googleTicket) {
      completeGoogleLogin(googleTicket, org, email)
      return
    }
    setStep("login")
  }

  // Step 3: Complete login with email, password, and head_office_id
  const handleCompleteLogin = async (data: LoginForm) => {
    if (!selectedOrg) {
      toast({
        // title: "Error",
        description: "Please select an organization first",
        variant: "destructive",
      })
      return
    }

    try {
      console.log("Login.tsx: Completing login with organization:", selectedOrg.head_office_id);
      setLoading(true)

      // Call login with email, password, and head_office_id
      const signedInUser = await loginSelect(email, data.password, selectedOrg.head_office_id)
      setLockNotice(null)

      console.log("Login.tsx: Login successful, showing success toast");
      toast({
        title: "Success",
        description: `Logged in to ${selectedOrg.company_name} successfully`,
      })

      console.log("Login.tsx: Navigating post-login");
      goAfterLogin(signedInUser);
      console.log("Login.tsx: Navigation completed");

    } catch (error: any) {
      console.error("Login.tsx: Login error occurred:", error)
      console.error("Login.tsx: Error message:", error?.message)

      const message = error?.message || "Invalid Credentials"
      setLockNotice(/locked/i.test(message) ? message : null)
      toast({
        // title: "Error",
        description: message,
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  // Where a signed-in user lands — identical for both sign-in flows.
  const goAfterLogin = (signedInUser: {
    role?: string
    subscription?: { workspace_mode?: string }
  }) => {
    if ((signedInUser.role || "").toLowerCase() === "superadmin") {
      // The platform superadmin has no company dashboard — go straight to
      // the superadmin console.
      navigate("/superadmin");
    } else {
      navigate(
        signedInUser.subscription?.workspace_mode === "limited"
          ? "/limited-workspace/dashboard"
          : "/dashboard"
      );
    }
  }

  // Google step 2: trade the ticket for a session in one workspace.
  const completeGoogleLogin = async (ticket: string, org: Organization, googleEmail: string) => {
    try {
      setLoading(true)
      const signedInUser = await googleLoginSelect(ticket, org.head_office_id, googleEmail)
      toast({
        title: "Success",
        description: `Logged in to ${org.company_name} successfully`,
      })
      goAfterLogin(signedInUser)
    } catch (error: any) {
      console.error("Login.tsx: Google login error:", error)
      toast({
        description: error.message || "Google sign-in failed",
        variant: "destructive",
      })
      // The ticket is short-lived and may be spent — send them back to the
      // start rather than leaving a workspace list that can no longer be used.
      handleBackToEmail()
    } finally {
      setLoading(false)
    }
  }

  // Google step 1: the ID token tells us who they are; the workspace list is
  // the same one the email step returns, because one email can belong to
  // several workspaces.
  const handleGoogleCredential = async (credential?: string) => {
    if (!credential) return

    try {
      setLoading(true)
      const response = await googleAuth(credential)

      setEmail(response.email)
      setGoogleTicket(response.ticket)
      setOrganizations(response.organizations || [])

      if ((response.organizations || []).length === 1) {
        await completeGoogleLogin(response.ticket, response.organizations[0], response.email)
      } else if ((response.organizations || []).length > 1) {
        setStep("organizations")
      } else {
        toast({
          description: "No organizations found for this Google account",
          variant: "destructive",
        })
      }
    } catch (error: any) {
      console.error("Login.tsx: Google auth error:", error)
      toast({
        description: error.message || "Google sign-in failed",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = async (data: LoginForm) => {
    if (step === "email") {
      await handleGetOrganizations(data)
    } else if (step === "login") {
      await handleCompleteLogin(data)
    }
  }

  const handleBackToEmail = () => {
    setStep("email")
    setOrganizations([])
    setSelectedOrg(null)
    setGoogleTicket(null)
  }

  const handleBackToOrganizations = () => {
    setStep("organizations")
    setSelectedOrg(null)
  }

  return (
    <div className="min-h-screen relative overflow-hidden text-[#1a1a1a]" style={{ background: "var(--gt-surface-1)", fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <style>{`
        @keyframes lg-fade-up { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes lg-pulse-dot { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }
        .lg-fade { animation: lg-fade-up 0.85s cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lg-stagger > * { animation: lg-fade-up 0.7s cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lg-stagger > *:nth-child(1) { animation-delay: 80ms; }
        .lg-stagger > *:nth-child(2) { animation-delay: 200ms; }
        .lg-stagger > *:nth-child(3) { animation-delay: 320ms; }
        .lg-stagger > *:nth-child(4) { animation-delay: 440ms; }
        .lg-stagger > *:nth-child(5) { animation-delay: 560ms; }
        .lg-stagger > *:nth-child(6) { animation-delay: 680ms; }
        .lg-stagger > *:nth-child(7) { animation-delay: 800ms; }
        .lg-pulse { animation: lg-pulse-dot 1.6s ease-in-out infinite; }
        .lg-grain {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.05 0'/></filter><rect width='240' height='240' filter='url(%23n)'/></svg>");
        }
        .lg-serif { font-family: 'Fraunces', 'Iowan Old Style', Georgia, serif !important; }
        .lg-mono { font-family: 'JetBrains Mono', ui-monospace, monospace !important; }
        .lg-eyebrow { font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 11px; letter-spacing: 0.22em; text-transform: uppercase; font-weight: 500; }
        .lg-input { background: transparent; border: 0; border-bottom: 2px solid #d6d0c2; outline: none; transition: border-color 200ms; font-family: 'Fraunces', Georgia, serif; font-size: 22px; color: #0f2d1f; padding: 10px 0; width: 100%; }
        .lg-input::placeholder { color: #b8b3ac; font-style: italic; }
        .lg-input:focus { border-bottom-color: #0f2d1f; }
        .lg-press { transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1), background 200ms; }
        .lg-press:hover { transform: translateY(-2px); }
        .lg-press:active { transform: translateY(0); }
        .lg-link-arrow { transition: transform 240ms cubic-bezier(0.33, 1, 0.68, 1); }
        .group:hover .lg-link-arrow, button:hover .lg-link-arrow, a:hover .lg-link-arrow { transform: translateX(4px); }
      `}</style>

      <div className="grid lg:grid-cols-12 min-h-screen">
        {/* LEFT — editorial pane (hidden on mobile) */}
        <div className="hidden lg:col-span-7 relative bg-[#0f2d1f] text-[#faf8f3] p-8 lg:p-14 lg:flex flex-col justify-between overflow-hidden">
          <div aria-hidden className="pointer-events-none absolute inset-0 lg-grain opacity-20 mix-blend-overlay" />
          <div aria-hidden className="pointer-events-none absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-[#1f4030] opacity-50 blur-3xl" />
          <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#1f4030] opacity-40 blur-3xl" />

          {/* Brand */}
          <button onClick={() => { window.location.href = process.env.REACT_APP_PUBLIC_SITE_URL || "/"; }} className="relative flex items-center gap-3 group lg-fade self-start" style={{ animationDelay: "60ms" }}>
            <div className="w-9 h-9 rounded-full bg-[#faf8f3] flex items-center justify-center">
              <FaUserClock className="text-[#0f2d1f] text-base" />
            </div>
            <div className="leading-tight text-left">
              <div className="lg-serif text-[20px] font-semibold tracking-tight flex items-center gap-2" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#faf8f3" }}>
                Teamlio
                <span className="lg-mono inline-flex items-center gap-1 bg-[#1f4030] px-1.5 py-0.5 rounded-full" style={{ fontSize: "8px", letterSpacing: "0.16em", color: "#d4a356" }}>
                  <FaRobot className="text-[8px]" /> AI
                </span>
              </div>
              {/* <div className="lg-eyebrow" style={{ fontSize: "9px", color: "#9eb3a4" }}>Est. 2024 · India</div> */}
            </div>
          </button>

          {/* Editorial body */}
          <div className="relative max-w-xl">
            <div className="flex items-center gap-3 mb-6 flex-wrap lg-fade" style={{ animationDelay: "180ms" }}>
              <span className="lg-eyebrow" style={{ color: "#9eb3a4" }}>Volume 01 — Spring 2026</span>
              <span className="h-px w-10 bg-[#9eb3a4]/40" />
              <span className="lg-eyebrow" style={{ color: "#d4a356" }}>Welcome back</span>
            </div>
            <h1
              className="lg-serif lg-fade"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                color: "#faf8f3",
                fontSize: "clamp(36px, 5vw, 60px)",
                lineHeight: 1,
                letterSpacing: "-0.025em",
                fontWeight: 500,
                animationDelay: "300ms",
              }}
            >
              Sign in to your
              <br />
              <span style={{ fontStyle: "italic", color: "#d4a356" }}>quiet workspace.</span>
            </h1>
            <p className="text-[16px] leading-[1.65] mt-6 max-w-md lg-fade" style={{ color: "#9eb3a4", animationDelay: "420ms" }}>
              The dashboard your team opens every morning. Live attendance, payroll preview, AI insights — all where you left them.
            </p>

            <ul className="mt-10 space-y-3.5 lg-stagger">
              {[
                { Icon: FaRobot, label: "Your AI employee, ready to draft", c: "#d4a356" },
                { Icon: FaCheckCircle, label: "Live attendance & payroll status", c: "#2f9e6c" },
                { Icon: FaShieldAlt, label: "End-to-end encrypted, hosted in India", c: "#9eb3a4" },
              ].map((cap, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-full bg-[#1f4030] flex items-center justify-center" style={{ color: cap.c }}>
                    <cap.Icon className="text-xs" />
                  </span>
                  <span className="text-[14px]" style={{ color: "#faf8f3" }}>{cap.label}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Pull quote */}
          <div className="relative max-w-xl lg-fade" style={{ animationDelay: "780ms" }}>
            <div
              className="lg-serif"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                color: "#faf8f3",
                fontStyle: "italic",
                fontSize: "clamp(18px, 1.8vw, 22px)",
                lineHeight: 1.35,
                fontWeight: 400,
              }}
            >
              "We closed our first month of payroll in 18 minutes — used to take a full Friday."
            </div>
            <div className="flex items-center gap-3 mt-4">
              <div className="w-9 h-9 rounded-full bg-[#1f4030] flex items-center justify-center text-[#d4a356] font-semibold text-sm">AK</div>
              <div className="leading-tight">
                <div className="text-[13px] font-semibold" style={{ color: "#faf8f3" }}>Anita Krishnan</div>
                <div className="lg-eyebrow" style={{ fontSize: "9px", color: "#9eb3a4" }}>Head of People · 240-person co.</div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — form pane */}
        <div className="lg:col-span-5 relative flex flex-col" style={{ background: "var(--gt-surface-1)" }}>
          <div aria-hidden className="pointer-events-none absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full bg-[#e8efe9] opacity-50 blur-3xl" />

          <div className="relative flex-1 flex items-center justify-center p-6 lg:p-12">
            <div className="w-full max-w-md lg-fade" style={{ animationDelay: "120ms" }}>
              {/* Step indicator */}
              <div className="flex items-center justify-between mb-8">
                <div className="lg-eyebrow text-[#8a8580]" style={{ fontSize: "10px" }}>
                  {step === "email" && "Step 01 of 02"}
                  {step === "organizations" && "Step 02 of 03"}
                  {step === "login" && (organizations.length > 1 ? "Step 03 of 03" : "Step 02 of 02")}
                </div>
                <div className="flex items-center gap-1.5">
                  {[1, 2, 3].map((n) => {
                    const isActive =
                      (n === 1 && step === "email") ||
                      (n === 2 && step === "organizations") ||
                      (n === 3 && step === "login");
                    const isPast =
                      (n === 1 && step !== "email") ||
                      (n === 2 && step === "login");
                    return (
                      <span
                        key={n}
                        className={`rounded-full transition-all duration-500`}
                        style={{
                          width: isActive ? 22 : 6,
                          height: 6,
                          background: isActive ? "#0f2d1f" : isPast ? "#1f4030" : "#d6d0c2",
                        }}
                      />
                    );
                  })}
                </div>
              </div>

              {/* Heading (changes per step) */}
              <div key={`heading-${step}`} className="lg-fade mb-8">
                <h2
                  className="lg-serif text-[#0f2d1f] mb-3"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: "clamp(28px, 3.4vw, 40px)",
                    lineHeight: 1.05,
                    letterSpacing: "-0.025em",
                    fontWeight: 500,
                  }}
                >
                  {step === "email" && (<>Welcome <span style={{ fontStyle: "italic" }}>back.</span></>)}
                  {step === "organizations" && (<>Choose your <span style={{ fontStyle: "italic" }}>workspace.</span></>)}
                  {step === "login" && organizations.length === 1 && (<>Welcome back to <span style={{ fontStyle: "italic" }}>{selectedOrg?.company_name}</span></>)}
                  {step === "login" && organizations.length > 1 && (<>Sign in to <span style={{ fontStyle: "italic" }}>{selectedOrg?.company_name}</span></>)}
                </h2>
                <p className="text-[14px] text-[#4a4a4a] leading-[1.6]">
                  {step === "email" && "Enter your work email to get started. We'll find your workspace."}
                  {step === "organizations" && `${organizations.length} workspaces found for ${email}. Choose one to continue.`}
                  {step === "login" && "Enter your password to step back inside."}
                </p>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                {/* Sign in with Google — the one-click path, so it leads.
                    Google renders (and size-caps) its own button, so the real
                    one is invisible and stretched over the button below, which
                    is ours and matches Continue exactly. */}
                {step === "email" && GOOGLE_CLIENT_ID && (
                  <>
                    <div className="relative rounded-full focus-within:ring-2 focus-within:ring-[#0f2d1f]/25">
                      {/* Same box rules as the Continue button below (py-3.5,
                          rounded-full, font-medium) so the two always match,
                          at every breakpoint. */}
                      <div
                        aria-hidden
                        className="w-full inline-flex items-center justify-center gap-3 py-3.5 rounded-full font-medium shadow-[inset_0_0_0_1px_#d6d0c2] bg-[#ffffff] text-[#1a1a1a] lg-press hover:bg-[#f4f1ea] transition-colors"
                      >
                        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
                          <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62Z" />
                          <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z" />
                          <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z" />
                          <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z" />
                        </svg>
                        <span>Sign in with Google</span>
                      </div>
                      <div ref={googleButtonRef} className="absolute inset-0 overflow-hidden opacity-0" />
                    </div>

                    <div className="flex items-center gap-3">
                      <span className="h-px flex-1 bg-[#e8e3d8]" />
                      <span className="lg-mono text-[#8a8580]" style={{ fontSize: "10px", letterSpacing: "0.18em", textTransform: "uppercase" }}>or use your email</span>
                      <span className="h-px flex-1 bg-[#e8e3d8]" />
                    </div>
                  </>
                )}

                {/* Step 1: Email */}
                {step === "email" && (
                  <div>
                    <label className="lg-eyebrow text-[#8a8580] block mb-2" style={{ fontSize: "10px" }}>Work email</label>
                    <input
                      type="email"
                      placeholder="you@company.com"
                      className="lg-input"
                      style={{ fontFamily: "'Fraunces', Georgia, serif" }}
                      {...register("email", { required: true })}
                    />

                  </div>
                )}

                {/* Step 2: Organizations */}
                {step === "organizations" && (
                  <div>
                    <label className="lg-eyebrow text-[#8a8580] block mb-3" style={{ fontSize: "10px" }}>Pick a workspace</label>
                    <div className="space-y-2 max-h-[360px] overflow-y-auto pr-2 -mr-2 lg-stagger">
                      {organizations.map((org, idx) => (
                        <button
                          key={idx}
                          type="button"
                          onClick={() => handleSelectOrganization(org)}
                          className="w-full text-left p-4 border border-[#e8e3d8] hover:border-[#0f2d1f] rounded-2xl transition-all group bg-[#faf8f3] hover:bg-[#fbf8f1]"
                        >
                          <div className="flex items-center gap-4">
                            <div className="w-11 h-11 rounded-xl bg-[#e8efe9] flex items-center justify-center text-[#0f2d1f]">
                              <FaBuilding />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="lg-serif text-[#0f2d1f] truncate" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "18px", fontWeight: 500, letterSpacing: "-0.01em" }}>
                                {org.company_name}
                              </div>
                              <div className="text-[12px] text-[#8a8580] truncate">{org.organization}</div>
                            </div>
                            <ArrowRight className="w-3.5 h-3.5 text-[#0f2d1f] lg-link-arrow shrink-0" />
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Step 3: Password */}
                {step === "login" && (
                  <div>
                    {lockNotice && (
                      <div
                        role="alert"
                        className="mb-3 rounded-2xl border border-[#e0b4a8] bg-[#fdf1ed] p-3 text-[12px] leading-relaxed text-[#7a2e1c]"
                      >
                        {lockNotice}
                      </div>
                    )}
                    <div className="flex items-center justify-between mb-2">
                      <label className="lg-eyebrow text-[#8a8580]" style={{ fontSize: "10px" }}>Password</label>
                      <button
                        type="button"
                        onClick={() => navigate("/forgot-password", { state: { email } })}
                        className="lg-mono text-[10px] text-[#0f2d1f] hover:underline"
                        style={{ letterSpacing: "0.12em", textTransform: "uppercase" }}
                      >
                        Forgot?
                      </button>
                    </div>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="••••••••"
                        className="lg-input pr-10"
                        style={{ fontFamily: "'Fraunces', Georgia, serif" }}
                        {...register("password", { required: true })}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword((p) => !p)}
                        className="absolute right-1 top-3 text-[#8a8580] p-2 hover:text-[#0f2d1f] transition-colors"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                    {selectedOrg && (
                      <div className="mt-4 inline-flex items-center gap-2 px-3 py-2 bg-[#e8efe9] rounded-full text-[12px] text-[#0f2d1f]">
                        <FaBuilding className="text-[10px]" />
                        Signing in to <strong className="font-semibold">{selectedOrg.company_name}</strong>
                      </div>
                    )}
                  </div>
                )}

                {/* Submit + back row */}
                <div className="pt-4 flex flex-col sm:flex-row gap-3">
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-[#0f2d1f] text-[#faf8f3] py-3.5 rounded-full font-medium lg-press hover:bg-[#0a1f15] disabled:opacity-60 disabled:cursor-not-allowed group"
                  >
                    {loading ? (
                      <>
                        <span className="w-4 h-4 rounded-full border-2 border-[#faf8f3] border-t-transparent animate-spin" />
                        <span>Working…</span>
                      </>
                    ) : (
                      <>
                        <span>
                          {step === "email" && "Continue"}
                          {step === "organizations" && "Select workspace"}
                          {step === "login" && "Sign in"}
                        </span>
                        <ArrowRight className="w-3.5 h-3.5 lg-link-arrow" />
                      </>
                    )}
                  </button>
                  {step === "organizations" && (
                    <button type="button" onClick={handleBackToEmail} className="inline-flex items-center justify-center gap-2 px-5 py-3 text-[13px] text-[#0f2d1f] hover:bg-[#ece8df] rounded-full transition-colors">
                      <ArrowLeft className="w-3.5 h-3.5" /> Back
                    </button>
                  )}
                  {step === "login" && organizations.length > 1 && (
                    <button type="button" onClick={handleBackToOrganizations} className="inline-flex items-center justify-center gap-2 px-5 py-3 text-[13px] text-[#0f2d1f] hover:bg-[#ece8df] rounded-full transition-colors">
                      <ArrowLeft className="w-3.5 h-3.5" /> Back
                    </button>
                  )}
                </div>

              </form>

              {/* Footer */}
              <div className="mt-10 pt-6 border-t border-dashed border-[#d6d0c2] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[13px]">
                <button onClick={() => { window.location.href = process.env.REACT_APP_PUBLIC_SITE_URL || "/"; }} className="text-[#8a8580] hover:text-[#0f2d1f] transition-colors inline-flex items-center gap-1.5 group">
                  <ArrowLeft className="w-3 h-3" /> Back to home
                </button>
                <button onClick={() => navigate("/register")} className="text-[#0f2d1f] hover:text-[#1f4030] inline-flex items-center gap-1.5 group font-medium">
                  New here? Create account <ArrowRight className="w-3 h-3 lg-link-arrow" />
                </button>
              </div>
            </div>
          </div>

          {/* Bottom strip */}
          <div className="relative px-6 lg:px-12 pb-6 flex items-center justify-between text-[#8a8580]">
            <div className="lg-mono" style={{ fontSize: "10px", letterSpacing: "0.18em", textTransform: "uppercase" }}>
              <span className="inline-flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#2f9e6c] lg-pulse" />
                Encrypted end-to-end
              </span>
            </div>
            <div className="lg-mono" style={{ fontSize: "10px", letterSpacing: "0.18em", textTransform: "uppercase" }}>
              © {new Date().getFullYear()} Teamlio
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
